import React, { useState, useEffect } from 'react';
import { Hero } from './components/Hero';
import { Navbar } from './components/Navbar';
import { Countdown } from './components/Countdown';
import { Venue } from './components/Venue';
import { Schedule } from './components/Schedule';
import { WhereToStay } from './components/WhereToStay';
import { QA } from './components/QA';
import { RSVP } from './components/RSVP';
import { Footer } from './components/Footer';

const App: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen relative overflow-x-hidden selection:bg-[#F5F2ED] selection:text-[#5D5445]">
      <Navbar isScrolled={scrolled} />
      
      <main>
        <section id="home">
          <Hero />
        </section>

        <div className="bg-white">
          <section id="countdown">
            <Countdown />
          </section>

          <section id="venue">
            <Venue />
          </section>

          <section id="schedule">
            <Schedule />
          </section>

          <section id="accommodation" className="bg-[#FAF9F6]">
            <WhereToStay />
          </section>

          <section id="qa">
            <QA />
          </section>

          <section id="rsvp" className="bg-[#FAF9F6]">
            <RSVP />
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default App;